import React from "react";
import { Image } from "../../../../../components/Image/Image";
import { CartUnavailableProductProps, ImageType, ProductImageTypes } from "@core/types";
import { useProductCardActions } from "../../../../../providers/useProductActions";

import cx from "classnames";
import { useHistory, useLocation } from "react-router";
import { useProductSubscriptionsStore } from "../../../../../providers/products";
import useAddProductSubscription from "../../../../../hooks/useAddProductSubscription";
import { useTranslation } from "react-i18next";
import useOpenProductDetailSheet from "../../../../../hooks/useOpenProductDetailSheet";

const CartUnavailableProduct = ({
  cartItem,
  product,
  className,
  removeProductCardTxt,
  removeUnavailableProduct,
  removeProductCardTxtClassName,
}: CartUnavailableProductProps) => {
  const { t } = useTranslation();
  const openProductDetailSheet = useOpenProductDetailSheet();
  const productImage = { ...product?.images[0], type: ProductImageTypes.img } as ImageType;

  const { productSubscriptionIdsMap } = useProductSubscriptionsStore.getState();
  const productSubscription = productSubscriptionIdsMap[product?.id!];
  const { handleAddProductSubscription, isLoading } = useAddProductSubscription(product?.id!);

  const { removeProductFromCart } = useProductCardActions();

  const handleShowProductDetail = () => {
    const id = cartItem.type === "variation" ? cartItem.parentId : cartItem.id;
    if (id) {
      openProductDetailSheet({ id: id, productType: cartItem.type });
    }
  };

  return (
    <div className="flex items-end justify-between w-full p-2.5 opacity-70" onClick={handleShowProductDetail}>
      <div className="flex gap-2.5">
        <Image
          className="w-[3.75rem] h-[3.75rem] object-cover rounded-md"
          lazyLoad={false}
          image={productImage}
          placeholder={productImage.base64}
        />

        <div className="flex flex-col gap-2.5">
          <span className="text-[#525252] text-xs truncate max-w-[12rem]">{cartItem.name}</span>

          <div className="flex items-center gap-1">
            <button
              className={cx(
                "p-2 text-[0.65rem] font-semibold rounded-full text-[#989898]  bg-[#EAEAEA]",
                removeProductCardTxtClassName,
              )}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                removeProductFromCart(product?.id!);
              }}
              disabled={product?.stockStatus !== "instock"}
            >
              {removeProductCardTxt}
            </button>
            <button
              disabled={!!productSubscription || isLoading}
              className={cx("p-2 text-[0.65rem] font-semibold rounded-full text-white bg-[#CDCDCD]")}
              onClick={handleAddProductSubscription}
            >
              {productSubscription ? t("Coming soon") : t("Notify")}
            </button>
          </div>
        </div>
      </div>

      <span className="font-bold text-[#525252]">{cartItem.quantity * Number(cartItem.price ?? 0)} ₽</span>
    </div>
  );
};

export default CartUnavailableProduct;
